import type { RouteObject } from 'react-router-dom';

import { defineHandle } from '@/app/routes/types';

import { inventoryAccessRoles } from './access';

export const inventoryRoutes: RouteObject[] = [
  {
    path: 'inventory',
    async lazy() {
      const { InventoryPage } = await import('./pages/InventoryPage');
      return { Component: InventoryPage };
    },
    handle: defineHandle({
      roles: [...inventoryAccessRoles],
      breadcrumb: 'breadcrumb.inventory',
      title: 'common:nav.inventory',
    }),
  },
  {
    path: 'quarantine-products',
    async lazy() {
      const { QuarantineProductsPage } = await import('./pages/QuarantineProductsPage');
      return { Component: QuarantineProductsPage };
    },
    handle: defineHandle({
      roles: ['admin'],
      breadcrumb: 'breadcrumb.quarantineProducts',
      title: 'common:nav.quarantineProducts',
    }),
  },
  {
    path: 'inventory/:storeId',
    async lazy() {
      const { DarkstoreInventoryPage } = await import('./pages/DarkstoreInventoryPage');
      return { Component: DarkstoreInventoryPage };
    },
    handle: defineHandle({
      roles: [...inventoryAccessRoles],
      breadcrumb: 'breadcrumb.inventoryStore',
      title: 'common:nav.inventory',
    }),
  },
];
